import { IMessageInfo } from '@cian/geosuggest-widget';

export const FLATS_NOT_FOUND_ERROR: IMessageInfo = {
  title: 'Ничего не найдено',
  text: 'Укажите другой адрес',
};

export const SERVER_ERROR: IMessageInfo = {
  title: 'Не удалось получить возможные варианты',
  text: 'Попробуйте еще раз',
};
